export const planets = [
    { name: "Mercúrio" },
    { name: "Vênus" },
    { name: "Marte" },
    { name: "Júpter" },
    { name: "Saturno" },
    { name: "Urano" },
    { name: "Netuno" },
    { name: "Sédina" },
    { name: "Céres" },
    { name: "Éris" },
    { name: "Hauméa" },
    { name: "Makémaké" },
]